module.exports = __webpack_public_path__ + "static/Banner-21-15c029b46da795029c20952e1c54d7ed.png";